import { render, staticRenderFns } from "./VerifyTips.vue?vue&type=template&id=0d93e279&scoped=true"
import script from "./VerifyTips.vue?vue&type=script&lang=js"
export * from "./VerifyTips.vue?vue&type=script&lang=js"
import style0 from "./VerifyTips.vue?vue&type=style&index=0&id=0d93e279&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d93e279",
  null
  
)

export default component.exports